const en = {
  Title: 'For Fastag queries, contact:',
  CallButton: 'Call Now',
  CETitle: 'Customer Support',
  CENumber: '9990033455',
  SETitle: ' (Sales Representative)',
  EventCallCustomerSupport: 'Teammate_Call_CE',
  EventCallSalesExecutive: 'Teammate_Call_Fastag_SE',
};

const STRINGS = (locale) => {
  switch (locale) {
    case 'en':
      return en;
    default:
      return en;
  }
};

export default STRINGS;
